import Link from "next/link";
import CtaArrowIcon from "@/components/icons/CtaArrowIcon";

export function InternalCTALink({ label, link, showIcon = true, className = "", align = "justify-center" }) {
  if (!link || !label) return null;
  return (
    <div className={`birch-cta flex ${align} md:px-0 xl:px-4 mt-6`}>
      <Link
        href={link}
        data-cy="cta-link"
        className={`group flex items-center rounded-full text-white bg-sea font-sans no-underline lg:h-fit px-5 py-3 text-base xl:text-lg ${className}`}
      >
        {label}
        {showIcon && <CtaArrowIcon />}
      </Link>
    </div>
  );
}

// Shared with VerifyPassCTALink so the two CTA styles can't drift apart.
export const externalCtaLinkClassName = "group flex items-center rounded-full text-white bg-sea hover:bg-sea-dark px-5 py-3 text-base xl:text-lg font-sans no-underline lg:h-fit";

export function ExternalCTALink({ label, link, showIcon = true, align = "justify-center" }) {
  if (!link || !label) return null;
  return (
    <div className={`birch-cta flex ${align} md:px-0 xl:px-4 mt-6`}>
      <Link
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label + ' (opens in a new tab)'}
        className={externalCtaLinkClassName}
      >
        {label}
        {showIcon && <CtaArrowIcon />}
      </Link>
    </div>
  );
}

export function ExternalTextLink({ label, link, className = "" }) {
  if (!link || !label) return null;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label + ' (opens in a new tab)'}
      className={`font-worksans text-sea flex justify-center mx-auto text-sm md:text-base underline ${className}`}
    >
      {label} <span aria-hidden="true">→</span>
    </a>
  );
}

// BL-652: `align` is opt-in and defaults to the centred layout every existing
// caller renders, so V1 is untouched. The V2 buy box card needs the flush
// variant: it sits in a `justify-between` row opposite Pricing Details, and
// the hardcoded `mx-auto` was centring it inside its own flex item instead of
// letting it sit against the right edge — which is what Richard flagged on
// PR #305. Helix's own button carries no auto margin there either.
export function ActionTextButton({
  label,
  onClick,
  align = 'center',
  size = 'base',
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center font-worksans py-0.5 text-sea cursor-pointer underline ${
        size === 'base' ? 'text-base' : 'text-sm'
      } ${
        align === 'center'
          ? 'justify-center text-center mx-auto'
          : 'justify-start text-left'
      }`}
    >
      {label}
    </button>
  );
}



export function ctaReferences(key) {
  return {
    [key + ".internal_link"]: ["url", "title", "uid"],
  };
}
